import logger from "./utils/Logger";

/** @deprecated Use Types below instead */
export * from "./types/global";
/** @deprecated Use Types below instead */
export * from './types';
export * as Types from "./types";

export * from './GlobalStorage';
export * from './Functions';

export * as Events from './events';
export * as Utils from './utils';
export * as Catalog from './catalog/';
export * as Alert from './alert/';
export * as Config from './config/';
export * as Status from './status/';
export * as Notification from './notification/';
export * as PoolDevice from "./pooldevice"; 
export * as Site from "./site";
export * as User from './user';

export function setLogLevel(level: string) {
    logger.setLogLevel(level);
}